import { Box, Typography } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import useTeceoStyles from '../../../../useTeceoStyles';
import { useTranslation } from '../../../translation/TranslationContext';

interface OrderValidationErrorProps {
  isFinishOrderValidation: boolean;
}

const OrderValidationErrors = ({ isFinishOrderValidation }: OrderValidationErrorProps) => {
  const { classes } = useTeceoStyles();
  const { translate } = useTranslation();

  return (
    <Box>
      <Typography gutterBottom variant="body2" className={classes.boldText}>
        {isFinishOrderValidation
          ? translate(LangEnum.ORDER_VALIDATION_UNABLE_TO_FINISH_ORDER)
          : translate(LangEnum.ORDER_VALIDATION_UNABLE_TO_ACCEPT_SUGGESTED_ORDER)}
      </Typography>
      <Typography variant="body2">
        {translate(LangEnum.ORDER_VALIDATION_SOLVE_ORDER_PENDENCIES)}
      </Typography>
    </Box>
  );
};

export default OrderValidationErrors;
